<template>
    <div>
        <div v-if="loadingHistory" class="pa-5 d-flex align-center justify-center">
            <loader/>
        </div>
        <div v-else-if="!history || !history.length" class="pa-2 text-overline grey--text text-center">
            No Activity History
        </div>
        <div v-else>
            <div class="d-flex align-center px-2 pt-2">
                <v-autocomplete
                    v-model="typeFilter"
                    :items="activityTypes"
                    placeholder="Filter by Type"
                    dense
                    hide-details
                    clearable
                    multiple
                    small-chips
                    deletable-chips
                    prepend-inner-icon="mdi-filter"
                    class="flex-grow-1 mr-2"
                />
                <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                        <v-btn icon small v-on="on" @click="exportCSV" color="secondary">
                            <v-icon small>mdi-download</v-icon>
                        </v-btn>
                    </template>
                    Export CSV
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                        <v-btn icon small v-on="on" @click="fullscreen = true" color="secondary">
                            <v-icon small>mdi-fullscreen</v-icon>
                        </v-btn>
                    </template>
                    Fullscreen
                </v-tooltip>
            </div>
            <v-data-table
                :items="filteredHistory"
                :headers="headers"
                dense
            >
                <template #item.date="{item}">
                    {{format(new Date(item.date), 'yyyy-MM-dd HH:mm')}}
                </template>
            </v-data-table>
        </div>

        <v-dialog v-model="fullscreen" fullscreen>
            <v-card class="fill-height d-flex flex-column of-y">
                <div class="px-3 white--text primary d-flex align-center justify-space-between">
                    <div class="py-2 text-h6">Activity History</div>
                    <div class="d-flex align-center">
                        <v-btn icon dark small @click="exportCSV" class="mr-1">
                            <v-icon small>mdi-download</v-icon>
                        </v-btn>
                        <v-btn icon dark small @click="fullscreen = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <div class="px-3 pt-2">
                    <v-autocomplete
                        v-model="typeFilter"
                        :items="activityTypes"
                        placeholder="Filter by Type"
                        dense
                        hide-details
                        clearable
                        multiple
                        small-chips
                        deletable-chips
                        prepend-inner-icon="mdi-filter"
                    />
                </div>
                <v-data-table
                    :items="filteredHistory"
                    :headers="headers"
                    dense
                    class="flex-grow-1"
                >
                    <template #item.date="{item}">
                        {{format(new Date(item.date), 'yyyy-MM-dd HH:mm')}}
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Loader from "@/components/General/Loader/Loader.vue";
import {format} from "date-fns";

export default {
    components: {Loader},
    props: {
        fkEmp: Number
    },
    data() {
        return {
            format,
            loadingHistory: false,
            history: null,
            fullscreen: false,
            typeFilter: [],
            headers: [
                {value: "date", text: "Date"},
                {value: "type", text: "Type"},
                {value: "description", text: "Description"},
            ]
        }
    },
    watch: {
        fkEmp: {
            immediate: true,
            handler() {
                this.initHistory();
            }
        }
    },
    methods: {
        async initHistory() {
            try {
                this.loadingHistory = true;
                this.history = await this.$newReq("POST", 'setup/emp/activityHistory', {id: this.fkEmp})
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingHistory = false
            }
        },
        exportCSV() {
            const rows = this.filteredHistory.map(item => ({
                date: format(new Date(item.date), 'yyyy-MM-dd HH:mm'),
                type: item.type,
                description: item.description
            }));
            const header = 'Date,Type,Description';
            const csv = [header, ...rows.map(r =>
                `${r.date},"${(r.type || '').replace(/"/g, '""')}","${(r.description || '').replace(/"/g, '""')}"`
            )].join('\n');
            const blob = new Blob([csv], {type: 'text/csv'});
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `activity_history_${this.fkEmp}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        }
    },
    computed: {
        activityTypes() {
            if (!this.history) return [];
            return [...new Set(this.history.map(h => h.type))].sort();
        },
        filteredHistory() {
            if (!this.history) return [];
            if (!this.typeFilter || !this.typeFilter.length) return this.history;
            return this.history.filter(h => this.typeFilter.includes(h.type));
        }
    },
}
</script>

<style scoped>

</style>
